import { Inject, Injectable, forwardRef } from "@angular/core";
import { DatetimeFormatterPipe } from "../shared/pipe";
import { AbstractExportContextService } from "./abstract-export-context.service";
import { AuthenticationService } from "./authentication.service";
import { FieldService } from "./field.service";

@Injectable()
export class TopBarExportContextService extends AbstractExportContextService {

    constructor(
        @Inject(forwardRef(() => AuthenticationService)) authenticationService: AuthenticationService,
        @Inject(forwardRef(() => DatetimeFormatterPipe)) datetimeFormatterPipe: DatetimeFormatterPipe,
        @Inject(forwardRef(() => FieldService)) fieldService: FieldService
    ) {
        super(authenticationService, datetimeFormatterPipe, fieldService);
    }

    isPdfExportAvailable(): boolean {
        return false;
    }

    getContextObject(): any {
        if (this.authenticationService.isLocationUser()) {
            return this.authenticationService.getUser().location;
        } else if (this.authenticationService.isCustomerUser()) {
            return this.authenticationService.getUser().customer;
        } else if (this.authenticationService.isPartnerUser()) {
            return this.authenticationService.getUser().partner;
        } else if (this.authenticationService.isOrganizationUser()) {
            return this.authenticationService.getUser().organization;
        }
        return null;
    }
}